<template>
    <div class="order-wrapper"  element-loading-text="拼命加载中">
        <create-order v-if="check_type == 1"></create-order>
        <close-order v-else-if="check_type == 2"></close-order>
        <!-- <close-order v-else-if="check_type == 2"></close-order> -->
        <revise-order v-else-if="check_type == 3"></revise-order>
        <FillOrder v-else-if="check_type == 4"></FillOrder>
        <view-order v-else ></view-order>
    </div>
</template>
<script>
    import CreateOrder from "~/views/order/approve/createOrder.vue";
    import CloseOrder from "~/views/order/approve/closeOrder.vue";
    import ReviseOrder from "~/views/order/approve/reviseOrder.vue";
    import FillOrder from "~/views/order/approve/fillOrder.vue";
    import ViewOrder from "~/views/order/approve/view.vue";
    import MessageService from "~/services/Message";

    export default {
        data() {
            return {
                check_type: 0,//审核订单类型 1新增2关闭3修订4补充
            };
        },
        components: {
            ViewOrder,
            CreateOrder,
            CloseOrder,
            ReviseOrder,
            FillOrder
        },
        created() {
            MessageService.readOrderMessage(this);
            this.check_type = this.$route.query['type'];
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/order/view.vue